<template>
  <div
    class="parking-map-toolbar"
    role="toolbar"
    aria-label="Управление разметкой парковки"
    @click.stop
    @dblclick.stop
    @mousedown.stop
    @touchstart.stop
  >
    <div class="parking-map-toolbar__drawing-control">
      <slot name="drawing-hint" />
      <button
        class="parking-map-toolbar__button"
        :class="{'is-active': isDrawing}"
        type="button"
        :aria-label="drawingButtonTitle"
        :title="drawingButtonTitle"
        :aria-pressed="String(isDrawing)"
        :disabled="pointsCount >= maxPoints && !isDrawing"
        @click="$emit('toggle-drawing')"
      >
        <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M6 6H18V18H6V6Z" />
          <circle cx="6" cy="6" r="1.8" />
          <circle cx="18" cy="6" r="1.8" />
          <circle cx="18" cy="18" r="1.8" />
          <circle cx="6" cy="18" r="1.8" />
        </svg>
      </button>
    </div>

    <button
      class="parking-map-toolbar__button"
      type="button"
      aria-label="Удалить разметку"
      title="Удалить разметку"
      :disabled="!pointsCount"
      @click="$emit('clear')"
    >
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M4 6.5H20" />
        <path d="M9 3.5H15" />
        <path d="M7 6.5L7.75 20H16.25L17 6.5" />
        <path d="M10 10V16.5M14 10V16.5" />
      </svg>
    </button>

    <button
      class="parking-map-toolbar__button"
      type="button"
      aria-label="Сохранить разметку"
      title="Сохранить разметку"
      :disabled="!canSave"
      @click="$emit('save')"
    >
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M5 12.5L9.5 17L19 7.5" />
      </svg>
    </button>
  </div>
</template>

<script>
import {
  MIN_PARKING_POLYGON_POINTS,
  MAX_PARKING_POLYGON_POINTS,
} from "@/components/pacs/analytics/parkingDetection/parkingPolygon.js";

/**
 * Нижняя панель инструментов разметки парковки на карте.
 */
export default {
  name: "ParkingMapMarkupToolbar",
  props: {
    isDrawing: {
      type: Boolean,
      default: false,
    },
    pointsCount: {
      type: Number,
      default: 0,
    },
    canSave: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    maxPoints() {
      return MAX_PARKING_POLYGON_POINTS;
    },
    drawingButtonTitle() {
      if (this.isDrawing) return "Завершить добавление точек";
      return this.pointsCount >= this.maxPoints
        ? `Достигнут максимум: ${this.maxPoints} точек`
        : "Добавить точки контура парковки";
    },
  },
};
</script>
